import React, { Component } from 'react';
import StepButtons from '../../StepButtons';
import styled from 'styled-components';
import SelectedButton from '../../SelectedButton';
import PrimaryText from '../PrimaryText';
import { MUSEUMS } from 'constants/index';
import RadioInput from 'components/RadioInput';

const SelectMuseumBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const SelectMuseumPrimaryBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  min-height: 500px;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const Content = styled.div`
  display: flex;
  width: 95%;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
`;

class SelectMuseumView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { step, state, changeStep, handleChange, museumMaping } = this.props;

    return (
      <SelectMuseumBox>
        <SelectMuseumPrimaryBox>
          <PrimaryText text="What types of museums interest you? Please select all that apply and rate your interest level low, medium, or high." />
          <Content>
            {MUSEUMS.map(museum => (
              <RadioInput
                style={{ marginBottom: 50 }}
                label={museum}
                name={museumMaping[museum]}
                options={[
                  { numericValue: 0, text: 'Nothing' },
                  { numericValue: 1, text: 'Low' },
                  { numericValue: 2, text: 'Medium' },
                  { numericValue: 3, text: 'High' },
                ]}
                handleChange={handleChange}
                currentValue={state[museumMaping[museum]]}
                verticalAlign
              />
            ))}
          </Content>
          <StepButtons
            backStep={() => changeStep(step - 1)}
            nextStep={() => changeStep(step + 1)}
          />
        </SelectMuseumPrimaryBox>
      </SelectMuseumBox>
    );
  }
}

export default SelectMuseumView;
